import { Gapper } from '../../../../../ui/utils';
import { CROSS_PROMOTIONAL_CONTENT } from './constants';
import {
  CrossPromotionalSectionWrapper,
  SectionPreHeading,
  SectionTitle,
  SectionDescription,
  SectionImage,
  SectionContentHeader,
  SectionContentListItem,
  SectionContenStyles,
  SectionContentListItemContainer,
  SectionBottomCaption,
  SectionButtonContainer,
} from './styles';
import CTAButton from '../../../../../ui/ctaButton';
import CheckIcon from '@mui/icons-material/Check';

const CrossPromotionalSection = () => {
  const handleButtonClick = () => {
    window.open('https://instituteofhypnotherapy.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <CrossPromotionalSectionWrapper>
      <Gapper gap={60}>
        <Gapper gap={30}>
          <SectionPreHeading>{CROSS_PROMOTIONAL_CONTENT.preHeading}</SectionPreHeading>
          <SectionTitle>{CROSS_PROMOTIONAL_CONTENT.title}</SectionTitle>
          <SectionDescription>{CROSS_PROMOTIONAL_CONTENT.description}</SectionDescription>
        </Gapper>
        <SectionImage src={CROSS_PROMOTIONAL_CONTENT.sectionImg} alt="Cross Promotional Section" />
        <Gapper gap={59}>
          <Gapper gap={28} styles={SectionContenStyles}>
            <SectionContentHeader>{CROSS_PROMOTIONAL_CONTENT.contentHeader}</SectionContentHeader>
            <Gapper gap={33}>
              {CROSS_PROMOTIONAL_CONTENT.contentList.map((item) => (
                <SectionContentListItemContainer key={item}>
                  <CheckIcon />
                  <SectionContentListItem>{item}</SectionContentListItem>
                </SectionContentListItemContainer>
              ))}
            </Gapper>
          </Gapper>
          <Gapper gap={42}>
            <SectionBottomCaption>{CROSS_PROMOTIONAL_CONTENT.bottomCaption}</SectionBottomCaption>
            <SectionButtonContainer>
              <CTAButton
                variant="contained"
                text={CROSS_PROMOTIONAL_CONTENT.buttonText}
                onClick={handleButtonClick}
              />
            </SectionButtonContainer>
          </Gapper>
        </Gapper>
      </Gapper>
    </CrossPromotionalSectionWrapper>
  );
};

export default CrossPromotionalSection;
